import { render, staticRenderFns } from "./index.vue?vue&type=template&id=740a895e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740a895e')) {
      api.createRecord('740a895e', component.options)
    } else {
      api.reload('740a895e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=740a895e&", function () {
      api.rerender('740a895e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DtFormItem/components/DtDateRange/index.vue"
export default component.exports